import { logger } from '@citation-js/core';
const typeMap = {
  article: 'article-journal',
  book: 'book',
  booklet: 'book',
  proceedings: 'book',
  manual: false,
  mastersthesis: 'thesis',
  misc: false,
  inbook: 'chapter',
  incollection: 'chapter',
  conference: 'paper-conference',
  inproceedings: 'paper-conference',
  online: 'website',
  patent: 'patent',
  phdthesis: 'thesis',
  techreport: 'report',
  unpublished: 'manuscript'
};

const parseBibTeXType = function (pubType) {
  if (!typeMap.hasOwnProperty(pubType)) {
    logger.unmapped('[plugin-bibtex]', 'publication type', pubType);
    return 'book';
  } else if (typeMap[pubType] === false) {
    return 'book';
  } else {
    return typeMap[pubType];
  }
};

export { parseBibTeXType as parse, parseBibTeXType as default };